import { render, staticRenderFns } from "./briefIntr.vue?vue&type=template&id=446523a2&scoped=true"
import script from "./briefIntr.vue?vue&type=script&lang=js"
export * from "./briefIntr.vue?vue&type=script&lang=js"
import style0 from "./briefIntr.vue?vue&type=style&index=0&id=446523a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446523a2",
  null
  
)

export default component.exports